// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-container {
  padding: 20px;
  overflow-y: auto;
}
.bordered-button {
  border: 1px solid var(--primary-color) !important;
  min-width: 120px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  object-fit: contain;
}
.store-container .header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.header-container .header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}
.header-container .btn-container {
  display: flex;
  gap: 15px;
  max-height: 35px;
}
.error {
  font-size: 12px;
  color: #f53232;
}
`, "",{"version":3,"sources":["webpack://./src/features/store-locations/StoreLocattion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".store-container {\n  padding: 20px;\n  overflow-y: auto;\n}\n.bordered-button {\n  border: 1px solid var(--primary-color) !important;\n  min-width: 120px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  object-fit: contain;\n}\n.store-container .header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.header-container .header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n.header-container .btn-container {\n  display: flex;\n  gap: 15px;\n  max-height: 35px;\n}\n.error {\n  font-size: 12px;\n  color: #f53232;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
